import { z } from "zod";

export const basicInfoSchema = z.object({
  cp_credentials: z.string().optional(),
  email: z.email("Enter a valid email address"),
  mobile: z.string().regex(/^\d{10}$/, "Contact number must be a valid 10-digit US number"),
  name: z.string().min(1, "Name is required"),
  user_type: z.string(),
});

export type BasicInfoFormValues = z.infer<typeof basicInfoSchema>;
